import classnames from "classnames";
import {ReactNode} from "react";
import {FaCheck, FaExclamation, FaPause} from "react-icons/fa6";

import {Service} from "@/lib/types/checks.ts";

export const CheckStatusIndicator = ({service}: {service: Service}) => {
  let cls: string;
  let title: string;
  let icon: ReactNode;

  if (!service.supports_downtime_alerting) {
    cls = "status-muted";
    title = "This check does not support downtime alerting.";
    icon = <></>;
  } else if (service.is_paused) {
    cls = "status-paused";
    title = "This check is currently paused.";
    icon = <FaPause />;
  } else if (!service.cached_state_is_up) {
    cls = "status-down";
    title = "This check is currently down.";
    icon = <FaExclamation />;
  } else {
    cls = "status-up";
    title = "This check is currently up.";
    icon = <FaCheck />;
  }

  return (
    <div className={classnames("status p-0", cls)} title={title}>
      {icon}
    </div>
  );
};
